import ads from './ads'
import recaptcha from "./social-media/recaptcha";
import Adsense from "./ads/adsense/adsense";

const domEvents = {}

/**
 * Specific method to listen scroll only once
 */
const oneUseScrollEvents = () => {
    if (document.readyState === 'complete' && window.pageYOffset >= 0 ) {
        ads.init();
        (new Adsense()).domInjection();
        recaptcha.domInjection();

        // Remove listener for one use purpose
        document.removeEventListener('scroll', oneUseScrollEvents)
    }
}

/**
 * Method to force display ads as soon the pages has been loaded
 */
const forceScrollToDisplayAds = () => {
    window.scrollTo(window.pageXOffset, window.pageYOffset + 1)
}

/**
 * Bind dom events here
 */
const bindEvents = () => {
    document.addEventListener('scroll', oneUseScrollEvents)
    // More events should be here
}

domEvents.init = () => {
    bindEvents();
    forceScrollToDisplayAds();
}

export default domEvents